
import DashboardComplianceNotFoundSvgComponent from "../../assets/svg-components/not-found/dashboard-compliance";
import './index.scss';


export default function DashboardSelfComplianceNotfound() {
  return (
    <>
      <div className="new-not-found-wrap">
        <div className="new-not-found-wrap__details config_vendors_not_found">
          <div className="not-found-image img-fluid not-found-image-config-vendors">
            <DashboardComplianceNotFoundSvgComponent />
          </div>
          <p className="no-data-found-text no-data-found-text-config-vendors">There are either no tasks assigned under your name, or the entity associated with you doesn't have any tasks scheduled for the given time frame.</p>
        </div>
      </div>
    </>
  );
}
